export default ["Ciclismo", "Viajar", "Video Juegos"];
